import { MainState } from "./state";
import { getStoreAccessors } from "typesafe-vuex";
import { State } from "../state";

export const getters = {
  hasAdminAccess: (state: MainState) => {
    return (
      state.userProfile &&
      state.userProfile.is_superuser &&
      state.userProfile.is_active
    );
  },
  hasAccountantAccess: (state: MainState) => {
    // return true;
    return (
      state.userProfile &&
      state.userProfile.is_superuser &&
      state.userProfile.is_active //&&
      // state.userProfile.id === 1
    );
  },
  loginError: (state: MainState) => state.logInError,
  dashboardShowDrawer: (state: MainState) => state.dashboardShowDrawer,
  dashboardMiniDrawer: (state: MainState) => state.dashboardMiniDrawer,
  userProfile: (state: MainState) => state.userProfile,
  token: (state: MainState) => state.token,
  mobile: (state: MainState) => state.mobile,
  isLoggedIn: (state: MainState) => state.isLoggedIn,
  isTokenSent: (state: MainState) => state.isTokenSent,
  firstNotification: (state: MainState) =>
    state.notifications.length > 0 && state.notifications[0],
  miners: (state: MainState) => state.miners,
  miner: (state: MainState) => (minerId: number) => {
    const filteredMiners = state.miners.filter((miner) => miner.id === minerId);
    if (filteredMiners.length > 0) {
      return { ...filteredMiners[0] };
    }
  },
  image: (state: MainState) => state.image,
  withdraws: (state: MainState) => state.withdraws,
  withdraw: (state: MainState) => (withdrawId: number) => {
    const filteredWithdraws = state.withdraws.filter(
      (withdraw) => withdraw.id === withdrawId
    );
    if (filteredWithdraws.length > 0) {
      return { ...filteredWithdraws[0] };
    }
  },

  withdrawStateName: (state: MainState) => (withdrawStateId: number) => {
    return state.withdrawStates.find(
      (withdrawState) => withdrawState.id === withdrawStateId
    )?.name;
  },
  withdrawStates: (state: MainState) => state.withdrawStates,
  shares: (state: MainState) => state.shares,
  calling: (state: MainState) => state.calling,
  incomes: (state: MainState) => state.incomes,
  companies: (state: MainState) => state.companies,
  company: (state: MainState) => (id: number) => {
    const filtered = state.companies.filter((item) => item.id === id);
    if (filtered.length > 0) {
      return { ...filtered[0] };
    }
  },isLicenceAccepted: (state: MainState) => state.isLicenceAccepted,

};

const { read } = getStoreAccessors<MainState, State>("");

export const readDashboardMiniDrawer = read(getters.dashboardMiniDrawer);
export const readDashboardShowDrawer = read(getters.dashboardShowDrawer);
export const readHasAdminAccess = read(getters.hasAdminAccess);
export const readHasAccountantAccess = read(getters.hasAccountantAccess);
export const readIsLoggedIn = read(getters.isLoggedIn);
export const readIsTokenSent = read(getters.isTokenSent);
export const readLoginError = read(getters.loginError);
export const readToken = read(getters.token);
export const readMobile = read(getters.mobile);
export const readUserProfile = read(getters.userProfile);
export const readFirstNotification = read(getters.firstNotification);
export const readMiners = read(getters.miners);
export const readOneMiner = read(getters.miner);
export const readWithdraws = read(getters.withdraws);
export const readOneWithdraw = read(getters.withdraw);
export const readShares = read(getters.shares);
export const readCalling = read(getters.calling);

export const readWithdrawStates = read(getters.withdrawStates);
export const readWithdrawStateName = read(getters.withdrawStateName);

export const readImage = read(getters.image);

export const readIncomes = read(getters.incomes);

export const readCompanies = read(getters.companies);
export const readOneCompany = read(getters.company);

export const readIsLicenceAccepted = read(getters.isLicenceAccepted);
